import { useState, type FormEvent } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "影视资讯", to: "/category/news" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 bg-primary-800/95 backdrop-blur-md border-b border-primary-900/60">
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center h-16 gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0">
            <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center">
              <i className="ri-movie-2-fill text-background-50 text-lg" />
            </span>
            <span className="font-heading font-extrabold text-background-50 text-lg tracking-wide">
              欧美日韩
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1 ml-4">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                    isActive
                      ? "text-background-50 font-semibold bg-primary-700"
                      : "text-primary-100 hover:text-background-50 hover:bg-primary-700/60"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <form
            onSubmit={handleSearch}
            className="hidden md:flex items-center flex-1 max-w-xs ml-auto"
          >
            <div className="relative w-full">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-primary-200 text-sm" />
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影片、剧集、资讯"
                className="w-full h-9 pl-9 pr-3 text-sm rounded-md bg-primary-900/70 text-background-50 placeholder:text-primary-300 border border-primary-700 focus:border-accent-500 focus:outline-none transition-colors"
              />
            </div>
          </form>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="打开菜单"
            className="md:hidden ml-auto w-9 h-9 flex items-center justify-center rounded-md text-background-50 hover:bg-primary-700 cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>

        <div className="md:hidden pb-3">
          <form onSubmit={handleSearch} className="relative w-full">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-primary-200 text-sm" />
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影片、剧集、资讯"
              className="w-full h-9 pl-9 pr-3 text-sm rounded-md bg-primary-900/70 text-background-50 placeholder:text-primary-300 border border-primary-700 focus:border-accent-500 focus:outline-none transition-colors"
            />
          </form>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-primary-900/60 bg-primary-800">
          <nav className="flex flex-col px-4 py-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 text-sm rounded-md transition-colors ${
                    isActive
                      ? "text-background-50 font-semibold bg-primary-700"
                      : "text-primary-100 hover:bg-primary-700/60"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}